<header class="container maintenance-header">
  <div class="maintenance-header text-secondary s_txt-sm border-bottom border-dark" >
    <div class="float-start"><strong>{{title}}:</strong> {{details }}</div>
    <div class="clearfix"></div>
  </div>
</header>